/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 3 = VideoAppointment (Video Appointment)
 *
 * 4 = VideoHandover (Video Handover)
 *
 * 5 = VirtualTestdrive (Virtual Testdrive)
 *
 * 10 = ServiceVideo (Service Video)
 */
export enum VideoType {
  /**
   * Video Appointment
   */
  VideoAppointment = 3,
  /**
   * Video Handover
   */
  VideoHandover = 4,
  /**
   * Virtual Testdrive
   */
  VirtualTestdrive = 5,
  /**
   * Service Video
   */
  ServiceVideo = 10,
}
